// @flow
import React, { Component } from 'react';
import type { IntlShape } from 'react-intl';

import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { SET_SYSTEM_PANEL_ID } from 'util/constants';
import localizedStrings from 'util/localizedStrings';
import type { System } from 'state/types';
import { setExtensisSystem } from 'state/commands/licenseCommands';

type Props = {
  activePanelId: ?string,
  hideDialogPanel: Function,
  intl: IntlShape,
  setExtensisSystem: typeof setExtensisSystem,
  systems: System[],
};

type State = {
  selectedValue: ?string,
};

export default class SetSystemDialog extends Component<Props, State> {
  handleClickSystemCheckbox: Function;
  isOkEnabled: Function;
  renderSystem: Function;
  submit: Function;

  constructor() {
    super();
    this.state = { selectedValue: undefined };
    this.handleClickSystemCheckbox = this.handleClickSystemCheckbox.bind(this);
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.renderSystem = this.renderSystem.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleClickSystemCheckbox(event: SyntheticMouseEvent<HTMLInputElement>) {
    if (event.currentTarget.checked) {
      this.setState({ selectedValue: event.currentTarget.id });
    }
  }

  isOkEnabled() {
    return this.state.selectedValue;
  }

  submit() {
    if (this.state.selectedValue) {
      this.props.setExtensisSystem(this.state.selectedValue);
      this.props.hideDialogPanel();
    }
  }

  renderSystem(system: System) {
    const { intl } = this.props;
    const label = `${intl.formatMessage(localizedStrings.LIC_SYSTEM_ID)}: ${
      system.systemId
    } ${intl.formatMessage(
      localizedStrings.LIC_MAINTENANCE_END_DATE
    )}: ${intl.formatDate(system.licensingInfo.maintenanceEndDate)}`;
    return (
      <div key={system.systemId}>
        <input
          checked={this.state.selectedValue === system.systemId}
          className="is-checkradio"
          id={system.systemId}
          onChange={this.handleClickSystemCheckbox}
          type="radio"
          name="selectedSystem"
        />
        <label htmlFor={system.systemId}>{label}</label>
        <div className="vertical-spacer-large" />
      </div>
    );
  }

  render() {
    const { activePanelId, hideDialogPanel, intl, systems } = this.props;
    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '600px', height: null }}
        hideDialogPanel={hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onSave={this.submit}
        panelId={SET_SYSTEM_PANEL_ID}
        panelTitle={intl.formatMessage(localizedStrings.LIC_SET_SYSTEM_TITLE)}
        showCancel
      >
        <div className="portfolio-form-container">
          {systems.map(system => this.renderSystem(system))}
        </div>
      </DialogPanel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/LicensesPage/SetSystemDialog.js